import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { AnalyticsService } from 'src/app/services/analytics/analytics.service';

@Component({
  selector: 'app-more-proyects',
  templateUrl: './more-proyects.component.html',
  styleUrls: ['./more-proyects.component.scss']
})
export class MoreProyectsComponent implements OnInit {
  Projects = [
    // {
     
    //   Title:'Fair Future Website',
    //   Description:'A website for booking holiday trips',
    //   Technologies:['Vue.js','Html','Css','javaScript'],
    //   ghLink:'',
    //   demoLink:'https://www.fairfuturetravels.com/'
    // },
    {
     
      Title:'Image Editor',
      Description:'It is a full-stack project that allows users to edit images online and download them.',
      Technologies:['React','Html','Css','Node.js'],
      ghLink:'https://github.com/sivaDev1212/image-filter-new',
      demoLink:''
    },


    // {
     
    //   Title:'techivo',
    //   Description:'techivo site  (personal practicing on design)',
    //   Technologies:['Html','Css','Animation','Responsive'],
    //   ghLink:'https://github.com/loayeldin/techivo',
    //   demoLink:'https://techivo.netlify.app/'
    // },

    // {
     
    //   Title:'devolio',
    //   Description:'devolio site  (personal practicing on design)',
    //   Technologies:['Html','Css','Animation','Responsive'],
    //   ghLink:'https://github.com/loayeldin/devolio',
    //   demoLink:'https://devoliooo.netlify.app/'
    // },

  ]
  constructor(
    private router: Router,
    public analyticsService: AnalyticsService
    ) { }

    ngOnInit() {
        this.router.events.subscribe((evt) => {
            if (!(evt instanceof NavigationEnd)) {
                return;
            }
            window.scrollTo(0, 0)
        });
    }
    redirect(route: string, event) {
      const id = event.target.id;
      if(id=='demoLink' || id=='ghLink'){
        return
      }
      window.open(route, '_blank');
    }

}
